__turbopack_context__.v({
  "mediaEmbedContainer": "MediaEmbed-module-scss-module__p0fh_G__mediaEmbedContainer",
});
